import useIdentityStore from '@/stores/useIdentityStore';
import useLawFirmStore from '@/stores/useLawFirmStore';

/**
 * One-stop shop for law firm scoping.
 *
 * - `activeLawFirmId` is what almost every page should use: the user's own
 *   firm by default, or the Super Admin's selection when one is made.
 * - `selectedLawFirmId` is the raw Super Admin selection (undefined = none),
 *   for surfaces where "no selection" means "all firms" (e.g. Billing).
 */
export function useLawFirmContext() {
    const isSuperAdmin = useIdentityStore((state) => state.isSuperAdmin);
    const myLawFirmId = useIdentityStore((state) => state.myLawFirmId);
    const myLawFirmName = useIdentityStore((state) => state.user?.lawFirm?.companyName);

    const selectedLawFirmId = useLawFirmStore((state) => state.selectedLawFirmId);
    const setSelectedLawFirmId = useLawFirmStore((state) => state.setSelectedLawFirmId);

    const activeLawFirmId = isSuperAdmin ? (selectedLawFirmId ?? myLawFirmId) : myLawFirmId;

    return {
        isSuperAdmin,
        myLawFirmId,
        myLawFirmName,
        selectedLawFirmId,
        activeLawFirmId,
        setSelectedLawFirmId,
    };
}
